import { get } from 'lodash';

import FilterDefinition from 'helpers/search_filters/filter_definition';
import CurrencyFormatter from '../../search_filters/formatters/currency_formatter';
import MeasurementFormatter from '../../search_filters/formatters/measurement_formatter';
import EnumFormatter from 'helpers/search_filters/formatters/enum_formatter';

const buildSelector = path => query => get(query, `saleFilter.${path}`);

export const leaseDate = new FilterDefinition({
  label: 'Lease Date',
  type: FilterDefinition.types.range,
  minValue: buildSelector('minLeaseDate'),
  maxValue: buildSelector('maxLeaseDate'),
});

export const leasePrice = new FilterDefinition({
  label: 'Lease Rate',
  formatter: new CurrencyFormatter(),
  type: FilterDefinition.types.range,
  minValue: buildSelector('minLeasePrice'),
  maxValue: buildSelector('maxLeasePrice'),
  unit: buildSelector('leaseRateUnits')
});

export const leaseSize = new FilterDefinition({
  label: 'Lease Space Size',
  formatter: new MeasurementFormatter(),
  type: FilterDefinition.types.range,
  minValue: buildSelector('minLeaseSize'),
  maxValue: buildSelector('maxLeaseSize'),
  unit: 'sf'
});

export const leaseType = new FilterDefinition({
  label: 'Lease Type',
  formatter: new EnumFormatter({
    1: 'Gross',
    2: 'Modified Gross',
    3: 'NNN',
    4: 'Modified Net',
    5: 'Full Service',
    6: 'Ground Lease',
  }),
  value: buildSelector('leaseType')
});

export const unitPrice = new FilterDefinition({
  label: 'Unit Price',
  formatter: new CurrencyFormatter(),
  type: FilterDefinition.types.range,
  minValue: buildSelector('minUnitPrice'),
  maxValue: buildSelector('maxUnitPrice')
});

export default [
  leaseDate,
  leasePrice,
  leaseSize,
  leaseType,
  unitPrice
];
